import(/* webpackMode: "eager", webpackExports: ["CardContainer"] */ "/vercel/path0/packages/app/src/features/card/CardContainer.tsx");
